<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}} <b-badge variant="success" class="border-radius">New</b-badge></h3>
                <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/new-reimbursement/payment">Payment Reimbursement</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6" class="mt-3 text-right">
                <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button>
                <b-button v-if="this.$route.query.status !== 'Paid'" v-b-tooltip.hover.top title="Pay" variant="primary" class="mr-1 float-right" @click="showModalPay('pay')"><font-awesome-icon icon="donate"></font-awesome-icon></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-3"/>
        <!--<template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>-->
        <b-form class="mt-3 mx-2">
            <b-row class="">
                <b-col md="9 mb-3 pl-0">
                  <table cellpadding="5">
                    <tr>
                      <td>No Request</td>
                      <td>:</td>
                      <td>{{model.noRequest !== null ? model.noRequest : '-'}}</td>
                    </tr>
                    <tr>
                      <td>Name</td>
                      <td>:</td>
                      <td>{{model.requestedBy !== null ? model.requestedBy : '-'}}</td>
                    </tr>
                     <tr>
                      <td>Category</td>
                      <td>:</td>
                      <td>{{model.reimburseCategory !== null ? model.reimburseCategory.categoryName : '-'}}</td>
                    </tr>
                    <tr>
                      <td>Receipt Date</td>
                      <td>:</td>
                      <td>{{model.receiptDate !== null ? model.receiptDate : '-'}}</td>
                    </tr>
                     <tr>
                      <td>Description</td>
                      <td>:</td>
                      <td>{{model.note !== null ? model.note : '-'}}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>:</td>
                      <td><b-badge :variant="getStatusColor($route.query.status)">{{$route.query.status}}</b-badge></td>
                    </tr>
                    <tr>
                      <td>Approved By</td>
                      <td>:</td>
                      <td>{{model.approvedBy}}</td>
                    </tr>
                    <!-- <tr>
                      <td>Paid Date</td>
                      <td>:</td>
                      <td v-if="model.paidTime === null">-</td>
                      <td v-else>{{model.paidTime !== null ? getDateTime(model.paidTime) : '-'}}</td>
                    </tr>
                    <tr>
                      <td>Paid Note</td>
                      <td>:</td>
                      <td>{{model.paidNote !== null ? model.paidNote : '-'}}</td>
                    </tr> -->
                  </table>
                </b-col>
                <b-col md="3 mb-3 pt-4" class="border border-radius text-right bg-total" style="max-height:80px">
                    <h5 style="padding-bottom:15px!important;"><strong>Total Amount : {{ dataAccount.account.currency }} {{formatPrice(model.amount)}}</strong></h5>
                    <div class="mt-5">
                     <h6>Payment Account :</h6>
                    <p>{{model.reimburseCategory.journalAccount.journalAccountName}}</p>
                    </div> 
                </b-col>

                <b-row class="mt-3 mb-3">
                <b-col>
                    <h5 class="pb-3">Photo</h5>
                </b-col>
                <b-col md="12">
                    <b-row v-if="model.reimbursePhoto.length === 0">
                        <b-col md="3">
                            <p class="text-secondary text-center d-flex border p-5"><i>No Photo Submitted</i></p>
                        </b-col>
                    </b-row>
                    <viewer :images="model.reimbursePhoto" v-else>
                        <b-row>
                            <b-col md="3" v-for="(src, index) in model.reimbursePhoto" :key="index">
                                <p class="text-secondary text-center border p-5" v-if="src === null"><i>No Photo Submitted</i></p>
                                <b-img v-else :src="src.url" class="img-responsive" width="300" height="200"/>
                            </b-col>
                        </b-row>
                    </viewer>
                </b-col>
            </b-row>
                <!--<b-col md="12">
                    <b-form-checkbox class="mb-3 float-right" @change="changeFilter(isActive)">This Month Only</b-form-checkbox>
                </b-col>
                <b-col md="12">
                    <b-form-checkbox class="mb-3 float-right">This Month Only</b-form-checkbox>
                </b-col>-->
                <!-- <b-col md="12 p-0">
                    <div class="table-responsive">
                    <table class="table table-hovered table-striped">
                        <thead>
                            <tr>
                                <th scope="col" width="240">Date</th>
                                <th width="100">Type</th>
                                <th width="650">Note</th>
                                <th width="150">Sub Total</th>
                                <th width="50"></th>
                            </tr>
                        </thead>
                        <tbody v-if="reimburseAmountStatsList.length > 0">
                            <tr v-for="(payment, index) in reimburseAmountStatsList" :key="index">
                                <td>{{getDateTime(payment.createdAt)}}</td>
                                <td>{{payment.reimburseType.name}}</td>
                                <td>{{payment.note}}</td>
                                <td>{{ dataAccount.account.currency }} {{formatPrice(payment.amount)}}</td>
                                <td>
                                    <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#/reimbursement/general/' + payment.uuid"></a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="9" class="text-center">there's no data</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </b-col> -->
            </b-row>
        </b-form>
        <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>

        <b-modal id="bv-modal-payment" hide-footer>
            <template v-slot:modal-title>
                <h5 class="text-transform">Pay Reimbursement</h5>
            </template>
            <!-- ================================================= -->
            <form v-on:submit.prevent="doChangeStatusPay()">
                <div class="d-block">
                    <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">Payment Date*</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  <div class="form-group" v-bind:class="errors.has('date') ? 'has-error' : ''">
                    <b-form-datepicker
                      data-vv-as="date"
                      name="date"
                      v-model="formData.paidTime"
                      v-bind:class="errors.has('date') ? 'is-invalid' : ''"
                      v-validate="'required'"
                      required
                      type="date"
                      class="form-control"
                      placeholder="Date"
                    />
                    <p v-if="errors.has('date') !== null"></p>
                  </div>
                </b-col>
              </b-row>

               <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">payment ref number</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  <b-form-input
                    type="text"
                    placeholder="ref number .."
                    v-model="formData.paidRefNumber"
                  ></b-form-input>
                </b-col>
              </b-row>

               <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">paid from*</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                 <v-select
                    id="mySelect"
                    label="text"
                    v-model="formData.paidFrom"
                    :options="list.listAccount"
                    :reduce="(text) => text.value"
                    class="style-chooser"
                    placeholder="select account jurnal"
                >
                <!-- <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!model.customer"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template> -->
              </v-select>
                </b-col>
              </b-row>


               <b-row class="mt-2">
                <b-col md="3">
                  <label for="" class="labels">Note</label>
                </b-col>
                <b-col md="1"></b-col>
                <b-col md="8">
                  <b-form-input
                    v-model="formData.note"
                    type="text"
                    placeholder="note .."
                  ></b-form-input>
                </b-col>
              </b-row>
                    <!-- <label for="" class="mb-1"><strong>Note</strong></label>
                    <b-form-input v-model="formData.note" required placeholder="Enter note"></b-form-input> -->
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-payment')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
            </form>
        </b-modal>

        <!-- <b-modal id="bv-modal-payment" hide-footer>
            <template v-slot:modal-title>
                <h5 class="text-transform">Pay Reimbursement</h5>
            </template>
            <form v-on:submit.prevent="doChangeStatusPay()">
                <div class="d-block">
                    <label for="" class="mb-1"><strong>Note</strong></label>
                    <b-form-input v-model="formData.note" required placeholder="Enter note"></b-form-input>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-payment')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
            </form>
        </b-modal> -->
    </b-card>
</template>

<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
    export default {
        name: 'reimbursement-show',
        data () {
            return {
                src: '',
                isActive: true,
                isLoading: false,
                dataAccount: this.$store.getters['account/accountData'],
                apiUrl: {
                    reimbursement: window.AppConfig.apiUrl + 'reimbursement',
                    reimburseAmountStats: window.AppConfig.apiUrl + 'reimburse-amount-stats',
                    reimbursementHistoryStatus: window.AppConfig.apiUrl + 'reimbursement-history-status',
                    exportPayment: window.AppConfig.apiUrl + 'export-payment-detail'
                },
                type: null,
                formData: {
                    requestedByUuid: null,
                    note: '',
                    reimbursement: '',
                    paidTime: '',
                    paidFrom: '',
                    paidRefNumber: ''
                },
                model: {
                    noRequest: '',
                    requestedBy: {
                        uuid: null,
                        name: null,
                        department: null
                    },
                    receiptDate: '',
                    amount: '',
                    paidDate: '',
                    paidTime: '',
                    paidNote: '',
                    startTime: '',
                    endTime: '',
                    status: '',
                    note: '',
                    createdAt: '',
                    changedBy: '',
                    reimburseType: null,
                    reimburseCategory: {
                        journalAccount: []

                    },
                    reimbursement: [],
                    reimbursePhoto: '',
                    statusValue: '',
                    statusText: '',
                    statusTime: '',
                    statusTextTime: '',
                    approvedBy: '',
                    destination: '',
                    totalMileage: '',
                    totalPetrol: '',
                    payment: {
                        totalAmount: null,
                        detailPayment: {
                            date: null,
                            type: {
                                Toll: null,
                                Food: null,
                                Petrol: null,
                                Mileage: null
                            }
                        }
                    }
                },
                list : {
                    listAccount: []
                },
                tableFilter: {
                    status: this.$route.query.status,
                    statusreimbursement: null,
                    requested_by: this.$route.query.requested_by,
                    userRequestedBy: {
                        value: null
                    },
                    date: null,
                    start_date: this.$route.query.start_date,
                    end_date: this.$route.query.end_date,
                },
                reimburseAmountStats: {
                    field: []
                },
                totalAmount: 0,
                reimbursementHistoryStatusList: [],
                reimburseAmountStatsList: []
            }
        },
        watch: {
            'fakeTableFilter.requestedBy' (value) {
                this.tableFilter.requestedBy = value ? 1 : null
                this.getDetailReimbursement()
            },
            'tableFilter.date' (value) {
                if (value.length >= 1 && value[0] === null && value[1] === null) {
                    this.tableFilter.date = null
                    this.getDetailReimbursement()
                } else {
                    this.getDetailReimbursement()
                }
            },
            'tableFilter.statusreimbursement' () {
                this.getDetailReimbursement()
            }
        },
        mounted () {
            this.getReimburseAmountStats()
            this.getDetailReimbursement()
            this.getHistoryStatus()
            this.getAccountList()
        },
        methods: {
            showModalPay (type, row) {
                this.formData.requestedByUuid = this.$route.params.uuid
                this.type = type
                this.$bvModal.show('bv-modal-payment')
            },
            doChangeStatusPay () {
                this.isLoading = true
                this.$http.post(window.AppConfig.apiUrl + 'paid-reimburse', {
                    reimbursement: this.formData.requestedByUuid,
                    note: this.formData.note,
                    paidNote: this.formData.note,
                    paidTime: this.formData.paidTime,
                    paidFrom: this.formData.paidFrom
                })
                .then((response) => {
                    this.isLoading = false
                    // this.formData.requestedByUuid = null
                    // this.formData.note = null
                    // this.getReimbursePaid()
                    this.$bvModal.hide('bv-modal-payment')
                    this.$store.dispatch('notification/success', 'Reimbursement has been paid')
                    this.$router.push('/new-reimbursement/history-reimbursement/' + this.$route.params.uuid)
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                });
            },
            doExportToExcel () {
              let url = this.apiUrl.exportPayment + '?token=' + this.$store.getters['account/tokens'].access_token + '&requested_by=' + this.$route.params.uuid + '&status=' + this.$route.query.status + '&start_date=' + this.$route.query.start_date + '&end_date=' + this.$route.query.end_date
              window.open(url)
            },

            getAccountList() {
                this.$http.get(window.AppConfig.apiUrl + 'journal-account' + '?journalAccountType=D').then((response) => {
                    response?.data?._embedded?.journal_account?.forEach((data) => {
                    this.list.listAccount.push({
                        value: data.uuid,
                        text: data.journalAccountCode + ' - ' + data.journalAccountName,
                    });
                    });
                });
            },
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.reimbursement + '/' + this.$route.params.uuid)
                .then(() => {
                    // this.model.noRequest = response.data.noRequest !== null ? response.data.noRequest : '-'
                    // this.model.requestedBy = response.data.requestedBy !== null ? response.data.requestedBy : '-'
                    // this.model.startTime = response.data.startTime !== null ? response.data.startTime : '-'
                    // this.model.endTime = response.data.endTime !== null ? response.data.endTime : '-'
                    // this.model.status = response.data.status !== null ? response.data.status : '-'
                    // this.model.note = response.data.note !== null ? response.data.note : '-'
                    // this.model.createdAt = response.data.createdAt !== null ? this.$moment(response.data.createdAt).format('YYYY-MM-DD hh:mm A') : '-'
                    // this.model.amount = response.data.amount !== null ? response.data.amount : '-' 
                    // if (response.data.rejectedBy !== null) {
                    //     this.model.statusText = 'Rejected By'
                    //     this.model.statusTextTime = 'Rejected Time'
                    //     this.model.statusValue = response.data.rejectedBy
                    //     this.model.statusTime = response.data.rejectedTime !== null ? this.$moment(response.data.rejectedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    // }
                    // if (response.data.approvedBy !== null) {
                    //     this.model.statusText = 'Approved By'
                    //     this.model.statusTextTime = 'Approved Time'
                    //     this.model.statusValue = response.data.approvedBy
                    //     this.model.statusTime = response.data.approvedTime !== null ? this.$moment(response.data.approvedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    // }
                    // if (response.data.paidBy !== null) {
                    //     this.model.statusText = 'Paid By'
                    //     this.model.statusTextTime = 'Paid Time'
                    //     this.model.statusValue = response.data.paidBy
                    //     this.model.statusTime = response.data.paidTime !== null ? this.$moment(response.data.paidTime).format('YYYY-MM-DD hh:mm A') : '-'
                    // }
                    // this.model.reimbursementPhotoList = []
                    // if (response.data.reimbursePhoto !== null) {
                    //     response.data.reimbursePhoto.forEach(data => {
                    //         this.model.reimbursementPhotoList.push(data.url)
                    //     })
                    // }
                    // this.model.reimburseType = response.data.reimburseType !== null ? response.data.reimburseType.name : '-'
                    // if(this.model.reimburseType === 'Petrol'){
                    //     this.model.totalPetrol = response.data.options !== null ? response.data.options[0].value : '-'
                    // }else{
                    //   this.model.destination = response.data.options !== null ? response.data.options[0].value : '-'
                    //   if (response.data.options !== null && response.data.options.length > 1) {
                    //       this.model.totalMileage = response.data.options !== null ? response.data.options[1].value : '-'
                    //   }
                    // }
                    this.getReimburseAmountStats()
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getHistoryStatus () {
                this.isLoading = true
                this.$http.get(this.apiUrl.reimbursementHistoryStatus + '?reimburse_uuid=' + this.$route.params.uuid + '&ascending=1').then(response => {
                    this.reimbursementHistoryStatusList = []
                    response.data._embedded.reimbursementHistoryStatus.forEach(data => {
                        this.reimbursementHistoryStatusList.push(data)
                    })
                    this.isLoading = false
                })
            },
            changeFilter (isActive) {
                this.$http.get(window.AppConfig.apiUrl + 'reimbursement/payment/' + this.$route.params.uuid + '?status' + this.$route.query.status + '&start_date=' + this.$route.query.start_date + '&end_date=' + this.$route.query.end_date)
                .then(response => {
                    this.totalAmount = 0
                    this.model.requestedBy = response.data._embedded.reimbursement[0].requestedBy
                    this.model.paidTime = response.data._embedded.reimbursement[0].paidTime
                    this.model.paidNote = response.data._embedded.reimbursement[0].paidNote
                    response.data._embedded.reimbursement.forEach(data => {
                        this.totalAmount += parseFloat(data.amount)
                        this.reimburseAmountStatsList.push(data)
                    })
                })
            },

            //ini yang ditampilkan di detail reimburst pada saat status Approved
            getDetailReimbursement () {
                this.isLoading = true
                let url = this.apiUrl.reimbursement + '/' + this.$route.params.uuid
                this.$http.get(url).then(resp => {
                    this.model.requestedBy = resp.data.requestedBy.name
                    this.model.paidTime = resp.data.paidTime
                    this.model.receiptDate = resp.data.receiptDate
                    this.model.note = resp.data.note
                    this.model.noRequest = resp.data.noRequest
                    this.model.reimburseCategory = resp.data.reimburseCategory
                    this.model.reimburseHistory = resp.data.reimburseHistory
                    this.model.amount = resp.data.amount
                    this.model.paidNote = resp.data.paidNote
                    this.model.approvedBy = resp.data.approvedBy
                    this.model.reimbursePhoto = resp.data.reimbursePhoto
                    this.reimburseAmountStats = []
                    if (resp.data.payment) {
                        resp.data.payment.forEach((data, index) => {
                            this.reimburseAmountStats.push(data)
                        })
                    }
                    this.isLoading = false
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getReimbursePaid () {
                this.isLoading = true
                let url = this.apiUrl.reimbursement + '?limit=1000&requested_by=' + this.$route.params.uuid + '&status=Paid'
                this.$http.get(url).then(response => {
                    this.totalAmount = 0
                    this.model.requestedBy = response.data._embedded.reimbursement.slice(1)[0].requestedBy
                    this.model.paidTime = response.data._embedded.reimbursement.slice(1)[0].paidTime
                    this.model.paidNote = response.data._embedded.reimbursement.slice(1)[0].paidNote
                    if (response.data.paidTime !== null) {
                        this.$route.query.status = 'Paid'
                        this.model.paidTime = response.data.paidTime !== null ? this.$moment(response.data.paidTime).format('YYYY-MM-DD hh:mm A') : '-'
                        this.model.paidNote = response.data.paidNote !== null ? response.data.paidNote : '-'
                    }
                    response.data._embedded.reimbursement.forEach(data => {
                        this.totalAmount += Math.round(data.amount)
                        this.reimburseAmountStatsList.push(data)
                    })
                })
            },
            getReimburseAmountStats () {
                this.isLoading = true
                let url = this.apiUrl.reimbursement + '?limit=1000&requested_by=' + this.$route.params.uuid
                if (this.$route.query.status !== undefined) {
                    url += '&status=' + this.$route.query.status
                }
                if (this.$route.query.start_date !== undefined && this.$route.query.start_date !== undefined) {
                    url += '&start_date=' + this.$route.query.start_date + '&end_date=' + this.$route.query.end_date
                }
                this.$http.get(url).then(response => {
                    this.totalAmount = 0
                    this.model.requestedBy = response.data._embedded.reimbursement[0].requestedBy
                    this.model.paidTime = response.data._embedded.reimbursement[0].paidTime
                    this.model.paidNote = response.data._embedded.reimbursement[0].paidNote
                    response.data._embedded.reimbursement.forEach(data => {
                        this.totalAmount += Math.round(data.amount)
                        this.reimburseAmountStatsList.push(data)
                    })
                    // totalAmount = response.data.payment[0].totalAmount
                    // this.reimburseAmountStatsList.totalAmount = totalAmount
                    // this.reimburseAmountStatsList.detailPayment = []
                    // Object.keys(response.data.payment[0].detailPayment[0].type).forEach(data => {
                    //     this.reimburseAmountStatsList.field.push(data)
                    // })
                    // let subTotal = 0
                    // response.data.payment[0].detailPayment.forEach((data, index) => {
                    //     this.reimburseAmountStatsList.detailPayment.push({
                    //         date: data.date,
                    //         type: data.type,
                    //         subTotal: 0
                    //     })
                    //     this.reimburseAmountStatsList.field.forEach(dataName => {
                    //         subTotal += data.type[dataName]
                    //         this.reimburseAmountStatsList.detailPayment[index].subTotal = subTotal
                            
                    //     })
                    // })
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace(',', '.')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (val) {
                case 'Approved':
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Requested':
                    return 'info'
                    // eslint-disable-next-line no-unreachable
                    break

                case 'Rejected':
                    return 'danger'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Paid':
                    return 'primary'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            hasRole (name) {
              let temp = false
              name.forEach((key) => {
                if (this.$store.getters['account/accountData'].role == key){
                  temp = true
                }
              })
              return temp
            }
        }
    }
</script>